var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23293_210016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11242 2.20642L0.884601 9.43476C0.848238 9.47122 0.821982 9.51728 0.809479 9.56677L0.00834464 12.7823C-0.0156196 12.8791 0.0128249 12.9821 0.0834672 13.0527C0.136918 13.1062 0.209748 13.1358 0.284246 13.1358C0.307064 13.1358 0.330403 13.133 0.353117 13.1272L3.5687 12.326C3.61881 12.3135 3.66435 12.2873 3.70071 12.251L10.9291 5.02315L8.11242 2.20642Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7202 1.2208L11.9156 0.416229C11.3778 -0.121507 10.4406 -0.120986 9.90352 0.416229L8.91797 1.40178L11.7346 4.21841L12.7202 3.23286C12.9888 2.96435 13.1367 2.60697 13.1367 2.22688C13.1367 1.84679 12.9888 1.48941 12.7202 1.2208Z",
    fill: "#0073EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23293_210016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1364,
    height: 13.1364,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.06f4979db191f23ce18d8a9d8d3202ca.svg";
export { ForwardRef as ReactComponent };